/**
 * Utility functions for handling authentication URLs
 */

/**
 * Removes all scud_api_token parameters from a URL
 * @param url - The URL to clean (string or URL object)
 * @returns Clean URL string without any scud_api_token parameters
 */
export const cleanScudTokenFromUrl = (url: string | URL): string => {
  const urlObj =
    typeof url === 'string' ? new URL(url) : new URL(url.toString());

  // Remove all instances of scud_api_token
  while (urlObj.searchParams.has('scud_api_token')) {
    urlObj.searchParams.delete('scud_api_token');
  }

  return urlObj.toString();
};

/**
 * Gets the first scud_api_token from URL parameters
 * @param url - The URL to extract token from
 * @returns The first token found or null
 */
export const extractScudTokenFromUrl = (url: string | URL): string | null => {
  const urlObj =
    typeof url === 'string' ? new URL(url) : new URL(url.toString());
  const tokens = urlObj.searchParams.getAll('scud_api_token');

  return tokens.length > 0 ? tokens[0] : null;
};

/**
 * Creates a clean redirect URL for SCUD authentication
 * @param currentUrl - Current page URL
 * @param loginUrl - SCUD login URL
 * @returns Complete login URL with clean redirect_uri
 */
export const createScudRedirectUrl = (
  currentUrl: string,
  loginUrl: string,
): string => {
  const cleanRedirectUrl = cleanScudTokenFromUrl(currentUrl);
  return `${loginUrl}?redirect_uri=${encodeURIComponent(cleanRedirectUrl)}`;
};
